function IconSimpleArrowLeft({ fill, stroke }) {
  return (
    <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 5L7.97101 0.817395C9.30406 0.0175656 11 0.977792 11 2.53238V7.46762C11 9.02221 9.30406 9.98243 7.97101 9.1826L1 5Z" fill={fill} stroke={stroke} />
    </svg>
  )
}

export default IconSimpleArrowLeft